import { render, staticRenderFns } from "./BrandVoiceCreateForm.vue?vue&type=template&id=34694136&scoped=true"
import script from "./BrandVoiceCreateForm.vue?vue&type=script&lang=js"
export * from "./BrandVoiceCreateForm.vue?vue&type=script&lang=js"
import style0 from "./BrandVoiceCreateForm.vue?vue&type=style&index=0&id=34694136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34694136",
  null
  
)

export default component.exports